<template>
  <BModalConfirmTemplate
    ref="modal"
    v-bind="$attrs"
    :title-text="$options.titleText"
    @closed="$emit('closed')"
    @click-success="uploadFile"
  >
    <v-overlay :value="isLoading" absolute color="white">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </v-overlay>

    <template v-if="!successMessage">
      <div class="ml-1 mb-2">
        <a v-if="fileTemplateUrl" :href="fileTemplateUrl" target="_blank">
          <u>Скачать Шаблон файла</u>
        </a>
      </div>
      <BFileInput
        v-bind="$attrs"
        :disabled="isLoading"
        :loading="isLoading"
        :label="label"
        small-chips
        show-size
        v-on="$listeners || {}"
        @change="onChange"
      >
        <template v-for="(_, key) in $scopedSlots" #[key]="props">
          <slot v-bind="props" :data="getData(props.item)" :name="key" />
        </template>
      </BFileInput>
    </template>

    <div v-if="successMessage" v-html="successMessage" />

    <div
      v-else-if="errorMessage"
      class="error--text ml-8"
      v-text="errorMessage"
    />

    <div class="pt-5 font-italic">
      <p>
        Столбец Организатор должен содержать логины пользователей, заполняющих
        формы в мероприятии.
      </p>
      <p>
        Столбец Куратор должен содержать логин пользователя, который является
        куратором для данного организатора. Куратор может быть региональным или
        федеральным.
      </p>
      <p>
        Столбец Эксперт должен содержать логины экспертов, которые могут
        проводить экспертизы для данного организатора. Эксперты соответствуют
        куратору: могут быть региональными или федеральными. Чтобы загрузить для
        одного куратора несколько экспертов, необходимо продублировать строки с
        информацией из столбцов Организатор, Куратор и Наблюдатель.
      </p>
      <p>
        Столбец Наблюдатель актуален для тех организаторов, которые курируются
        на федеральном уровне. В этом случае в столбце Наблюдатель указывается
        логин регионального координатора. Этот пользователь будет иметь право на
        просмотр информации, но не сможет ничего менять.
      </p>
    </div>
  </BModalConfirmTemplate>
</template>

<script>
import BAteTreeParticipantsImportModal, {
  SUCCESS_MESSAGE,
} from '@/components/forms/BAteTree/BAteTreeParticipantsImportModal.vue'
import BModalConfirmTemplate from './BModalConfirmTemplate.vue'
import { MunMehApi } from '@/api/resources'
import { getErrorMessages } from '@/helpers/getErrorMessages'
import BFileInput from '@/components/forms/BFileInput.vue'

export default {
  name: 'PublicationMunMehImportModal',
  components: {
    BModalConfirmTemplate,
    BFileInput,
  },
  extends: BAteTreeParticipantsImportModal,
  titleText: 'Импорт кураторов, экспертов и наблюдателей',
  props: {
    munMehId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    label: 'Файл',
    fileTemplateUrl: '/files/curators_import.xlsx',
  }),
  methods: {
    async uploadFile() {
      this.errorMessage = null
      this.isLoading = true

      const api = new MunMehApi()
      try {
        await api.importCurators(this.munMehId, this.file)
        this.successMessage = SUCCESS_MESSAGE
        this.$refs.modal.onSubmit()
      } catch (e) {
        this.errorMessage = getErrorMessages(e).join(', ')
      } finally {
        this.isLoading = false
      }
    },
    onChange(file) {
      this.file = file
    },
  },
}
</script>
